import { testimonials } from '@/mocks/comics';

const principles = [
  { icon: 'ri-eye-line', title: '人肉筛选', desc: '不靠热度机械排序，每一部精选都由编辑亲手读过再推荐。' },
  { icon: 'ri-flask-line', title: '真实口碑', desc: '综合读者长期反馈与作品质量，只把经得起追的作品放上书单。' },
  { icon: 'ri-refresh-line', title: '每日更新', desc: '书单与榜单每日刷新，紧跟连载节奏，不错过任何一部好漫画。' },
  { icon: 'ri-quill-pen-line', title: '编辑手记', desc: '每份书单附走心推荐语，告诉你为什么值得追、适合谁追。' },
];

export default function About() {
  return (
    <section id="about" className="w-full bg-background-950 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-12 max-w-2xl">
          <span className="mb-3 inline-flex items-center gap-1.5 text-sm font-medium text-accent-400">
            <i className="ri-team-line" />
            ABOUT US
          </span>
          <h2 className="font-heading text-2xl font-bold text-foreground-50 md:text-4xl">
            编辑团队与网站口碑
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-400 md:text-base">
            香蕉漫画社由一群资深漫画编辑与骨灰级读者组成，我们把"帮你找到值得追的好漫画"当作唯一目标。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {principles.map((p) => (
            <div
              key={p.title}
              className="rounded-xl border border-background-800 bg-background-900/60 p-6 transition-colors hover:border-secondary-500/40"
            >
              <span className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500/15 text-2xl text-primary-400">
                <i className={p.icon} />
              </span>
              <h3 className="font-heading text-base font-bold text-foreground-50">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-400">{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {testimonials.map((t) => (
            <figure
              key={t.id}
              className="flex flex-col gap-4 rounded-xl border border-background-800 bg-background-900/60 p-6 md:flex-row md:items-start"
            >
              <img
                src={t.avatar}
                alt={`读者 ${t.name} 的头像`}
                title={`读者口碑 - ${t.name}`}
                className="h-14 w-14 shrink-0 rounded-full object-cover object-top"
                loading="lazy"
              />
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-2">
                  <figcaption className="text-sm font-bold text-foreground-50">{t.name}</figcaption>
                  <span className="rounded-md bg-secondary-500/15 px-2 py-0.5 text-xs text-secondary-300">{t.role}</span>
                </div>
                <div className="flex items-center gap-0.5 text-primary-400">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm" />
                  ))}
                </div>
                <blockquote className="text-sm leading-relaxed text-foreground-300">“{t.content}”</blockquote>
              </div>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}